import React from 'react';
const STATS = [{
  value: '+500',
  label: 'Yoga Instructors'
}, {
  value: '1 + 5',
  label: 'Box Set & Bonuses'
}, {
  value: '4.9/5',
  label: 'Average Rating'
}, {
  value: 'Worldwide',
  label: 'Trusted Globally'
}];
export function Stats() {
  return <section aria-label="Key numbers" className="w-full bg-ivory px-4 pb-8 sm:px-6" data-id="element-206" data-mp="2j01pmt8mgr83">
      <div className="mx-auto max-w-6xl" data-id="element-207" data-mp="2nv7bjs20y5w6">
        <p className="mb-3 text-center font-head text-[11px] font-bold uppercase tracking-wider text-softgray sm:text-sm" data-id="element-208" data-mp="298e4tb6km8fl">
          Built for yoga instructors who want everything ready
        </p>
        <dl className="grid grid-cols-2 divide-y divide-brand/10 overflow-hidden rounded-2xl border border-brand/15 bg-white sm:divide-y-0 lg:grid-cols-4" data-id="element-209" data-mp="207pryjswye4a">
          {STATS.map(stat => <div key={stat.label} className="flex flex-col items-center justify-center border-brand/10 px-3 py-4 text-center sm:border-r sm:last:border-r-0" data-id="element-210" data-mp="1q9a1mj1pn8vu">
              <dt className="sr-only" data-id="element-211" data-mp="55rim8d0xylw">{stat.label}</dt>
              <dd className="font-head text-xl font-extrabold uppercase text-brand-dark sm:text-3xl" data-id="element-212" data-mp="546m4d75g5le">
                {stat.value}
              </dd>
              <p className="mt-0.5 font-head text-[10px] font-semibold uppercase tracking-wide text-softgray sm:text-xs" data-id="element-213" data-mp="e662d3acb5na">
                {stat.label}
              </p>
            </div>)}
        </dl>
      </div>
    </section>;
}